export default {
  en: {
    rateCode: 'Rate Code',
    keyword: 'Keyword',
    newRateCode: 'New Rate Code',
    default: 'Default',
    code: 'Code',
    name: 'Name',
    totalPeriod: 'Total <br /> Period',
    totalRoom: 'Total <br> Room',
    status: 'Status',
    includeBreakfast: 'Include<br>Breakfast',
    yes: 'Yes',
    no: 'No',
    lastUpdate: 'Last<br>Updated',
    viewRate: 'View Rate',
    confirmRemoveRateCodeTitle: 'Confirm',
    confirmRemoveRateCodeMessage: 'Confirm to delete <strong>{rateCodeName}({rateCode})</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeRateCodeSuccess: 'Remove rate code success',
    viewRateEmptyPeriodList: 'No rate for this rate code, Please setup rate period',
    updateIsDefaultRateCodeSuccess: 'Update default rate code success'
  },
  th: {
    rateCode: 'ประเภทเรท',
    keyword: 'คำที่ต้องการค้นหา',
    newRateCode: 'สร้างเรท',
    default: 'ค่าเริ่มต้น',
    code: 'โค้ด',
    name: 'ชื่อ',
    totalPeriod: 'ช่วงเวลา<br />ทั้งหมด',
    totalRoom: 'ห้อง<br />ทั้งหมด',
    status: 'สถานะ',
    includeBreakfast: 'รวมอาหารเช้า',
    yes: 'ใช่',
    no: 'ไม่ใช่',
    lastUpdate: 'แก้ไขล่าสุด',
    viewRate: 'ดูเรท',
    confirmRemoveRateCodeTitle: 'ยืนยัน',
    confirmRemoveRateCodeMessage: 'กรุณายืนยันการลบ <strong>{rateCodeName}({rateCode})</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeRateCodeSuccess: 'Remove rate code success',
    viewRateEmptyPeriodList: 'ไม่มีราคาสำหรับเรทนี้, กรุณาตั้งค่าราคาเรท',
    updateIsDefaultRateCodeSuccess: 'แก้ไขการตั้งค่าเริ่มต้นสำเร็จ'
  }
}
